import React from "react";
import { Pencil, Trash } from "../../constant";
import classes from "./EditAndDeleteAction.module.css";
const EditAndDeleteAction = ({ onDelete, onEdit }) => {
  return (
    <div className={classes.wrapper}>
      <button onClick={onEdit}>
        <Pencil />
      </button>
      <button className={classes.deleteButton} onClick={onDelete}>
        <Trash />
      </button>
    </div>
  );
};

export default EditAndDeleteAction;
